"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var document_manager_config_provider_1 = require("../api/document-manager-config.provider");
var document_manager_config_model_1 = require("../../models/document-manager-config.model");
var HttpDocumentManagerConfigProvider = /** @class */ (function (_super) {
    __extends(HttpDocumentManagerConfigProvider, _super);
    function HttpDocumentManagerConfigProvider(applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.applicationPropertiesService = applicationPropertiesService;
        return _this;
    }
    HttpDocumentManagerConfigProvider.prototype.loadDocumentManagerConfig = function () {
        var defaultDocumentManagerConfigModel = new document_manager_config_model_1.DocumentManagerConfigModel();
        return this._loadConfig$().pipe(operators_1.map(function (documentManagerConfigModel) { return documentManagerConfigModel ? documentManagerConfigModel : defaultDocumentManagerConfigModel; }));
    };
    HttpDocumentManagerConfigProvider.prototype._loadConfig$ = function () {
        if (!this.documentManagerConfigs$) {
            this.documentManagerConfigs$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) { return value[document_manager_config_provider_1.DocumentManagerConfigProvider.DOCUMENT_MANAGER_CONFIGS_KEY]
                ? JSON.parse(value[document_manager_config_provider_1.DocumentManagerConfigProvider.DOCUMENT_MANAGER_CONFIGS_KEY])
                : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.documentManagerConfigs$;
    };
    HttpDocumentManagerConfigProvider = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpDocumentManagerConfigProvider);
    return HttpDocumentManagerConfigProvider;
}(document_manager_config_provider_1.DocumentManagerConfigProvider));
exports.HttpDocumentManagerConfigProvider = HttpDocumentManagerConfigProvider;
//# sourceMappingURL=http-document-manager-config.provider.js.map